<div *ngIf="!hidden" (click)="close()" class="fixed left-0 top-0 flex h-screen w-screen md:h-full md:w-full items-center justify-end bg-primary bg-opacity-50 md:py-10 z-75">

    <div
        (click)="$event.stopPropagation()"
        [ngClass]="{'animate-slide-in-left': !hidden, 'animate-slide-out-right': hide}"
        [ngClass]="classes"
        class="top-0 right-0 bg-white z-75 h-screen md:w-max shadow p-6 pt-0 overflow-auto max-w-100percent md:max-w-650px"
    >

        <div class="sticky top-0 z-10 flex justify-end bg-white pt-6">
            <button (click)="close()" class="focus:outline-none p-1.5 w-6 h-6 mb-4 flex items-center justify-center bg-info border border-info rounded-full transition ease-out duration-300 hover:border-primary">
                <img src="./assets2023/img/icons/close.svg" alt="Cerrar" width="8" height="8" />
            </button>
        </div>

        <ng-content></ng-content>

    </div>
</div>
